import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const translations = {
  ka: {
    backToHome: "მთავარ გვერდზე დაბრუნება",
    pageTitle: "ინდუსტრიული ლითონის დამუშავება",
    description: "მაღალი ხარისხის ლითონის კონსტრუქციები და აღჭურვილობა სასოფლო-სამეურნეო ბიზნესებისთვის",
    detailedInfo: "ჩვენ ვთავაზობთ ინდუსტრიული ლითონის დამუშავების სრულ სპექტრს, მათ შორის ჩარჩოების, პლატფორმების და სპეციალიზებული აღჭურვილობის წარმოებას სასოფლო-სამეურნეო და სამრეწველო გამოყენებისთვის.",
    features: "ძირითადი მახასიათებლები",
    feature1: "პრემიუმ ხარისხის ლითონის მასალები",
    feature2: "პროფესიონალური შედუღება და დამუშავება",
    feature3: "კორეზიის წინააღმდეგ დაფარვა",
    feature4: "ინდივიდუალური დიზაინი",
    feature5: "სწრაფი წარმოება",
    feature6: "გარანტიის უზრუნველყოფა"
  },
  en: {
    backToHome: "Back to Home",
    pageTitle: "Industrial Metal Fabrication",
    description: "High-quality metal structures and equipment for agricultural businesses",
    detailedInfo: "We offer a complete range of industrial metal fabrication services, including the production of frames, platforms, and specialized equipment for agricultural and industrial use.",
    features: "Key Features",
    feature1: "Premium quality metal materials",
    feature2: "Professional welding and processing",
    feature3: "Anti-corrosion coating",
    feature4: "Custom design",
    feature5: "Fast production",
    feature6: "Warranty guarantee"
  },
  ru: {
    backToHome: "Вернуться на главную",
    pageTitle: "Промышленная обработка металла",
    description: "Высококачественные металлоконструкции и оборудование для сельскохозяйственного бизнеса",
    detailedInfo: "Мы предлагаем полный спектр услуг по промышленной обработке металла, включая производство рам, платформ и специализированного оборудования для сельскохозяйственного и промышленного использования.",
    features: "Основные характеристики",
    feature1: "Металлические материалы премиум качества",
    feature2: "Профессиональная сварка и обработка",
    feature3: "Антикоррозионное покрытие",
    feature4: "Индивидуальный дизайн",
    feature5: "Быстрое производство",
    feature6: "Гарантийное обеспечение"
  }
};

export default function ServiceMetalFabrication({ language = 'ka' }) {
  const navigate = useNavigate();
  const t = translations[language];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="max-w-5xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/')}
          className="flex items-center space-x-2 text-slate-700 hover:text-orange-500 mb-8 transition"
        >
          <ArrowLeft size={20} />
          <span>{t.backToHome}</span>
        </button>

        <div className="bg-white rounded-xl shadow-lg overflow-hidden">
          <img 
            src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200"
            alt={t.pageTitle}
            className="w-full h-96 object-cover"
          />
          
          <div className="p-8">
            <h1 className="text-4xl font-bold text-slate-800 mb-4">{t.pageTitle}</h1>
            <p className="text-xl text-slate-600 mb-8">{t.description}</p>
            
            <p className="text-slate-700 mb-8 leading-relaxed">{t.detailedInfo}</p>

            <h2 className="text-2xl font-bold text-slate-800 mb-4">{t.features}</h2>
            <ul className="space-y-3">
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature1}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature2}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature3}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature4}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature5}</span>
              </li>
              <li className="flex items-start">
                <span className="text-orange-500 mr-3">✓</span>
                <span className="text-slate-700">{t.feature6}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
